import {
  ForwardMethod,
  MessageActionType,
  ScopeModel,
  TargetAuthHeader,
  TargetModel,
  TargetStatus,
} from '../../../modules/Apps';

export interface TargetAuthHeaderFormValue extends TargetAuthHeader {
  removed?: boolean;
  editing?: boolean;
}

export interface TargetsFormValues {
  appId: string;
  name: string;
  forwardUrl: string;
  forwardMethod: ForwardMethod;
  status: TargetStatus;
  scopes: ScopeModel[];
  message?: string;
  messageActionType: MessageActionType;
  authHeaders: TargetAuthHeaderFormValue[];
}

export const TargetsFormValuesToDto = (
  {
    appId,
    forwardMethod,
    forwardUrl,
    name,
    status,
    scopes,
    message,
    messageActionType,
    authHeaders,
  }: TargetsFormValues,
  targetId?: string,
): TargetModel => {
  return {
    appId,
    forwardMethod,
    forwardUrl,
    name,
    targetId,
    status,
    scopes,
    messageActionType,
    message,
    authHeaders: authHeaders?.filter(authHeader => !authHeader.removed),
  } as TargetModel;
};
